import Vue from 'vue'
import App from './App.vue'
import jQuery from 'jquery'
import store from './config/store'
import router from './router'
import VueNumeric from 'vue-numeric'
import VueMoment from 'vue-moment'
import Vuesax from 'vuesax'
import 'vuesax/dist/vuesax.css'
import VueMask from 'v-mask'
import 'material-icons/iconfont/material-icons.css';

const VueScrollTo = require('vue-scrollto')
Vue.use(Vuesax,VueMask,VueScrollTo)

if (!Vue.moment) {
  Vue.use(VueMoment)
}
Vue.use(VueNumeric)
import axios from 'axios'
Vue.use(axios)
Vue.use(VueMask);
import './global/msg'
import './global/utils'
import './config/axios'

global.jQuery = jQuery
global.$ = jQuery
import 'popper.js'

Vue.config.productionTip = false
new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
